import React, { useState } from "react";
import EmojiPicker, { EmojiClickData } from "emoji-picker-react";

interface ChatInputProps {
    onSend: (message: string) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSend }) => {
    const [message, setMessage] = useState("");
    const [showEmojiPicker] = useState(false);

    const handleSend = () => {
        if (message.trim()) {
            onSend(message);
            setMessage("");
        }
    };

    const handleEmojiClick = (emojiData: EmojiClickData) => {
        setMessage((prev) => prev + emojiData.emoji);
    };

    return (
        <div className="relative">
            {showEmojiPicker && (
                <div className="absolute bottom-12 right-12">
                    <EmojiPicker onEmojiClick={handleEmojiClick} />
                </div>
            )}
            <div className="flex items-center">
                <input
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Enter your text here..."
                    className="flex-1 p-2 border rounded"
                />
                {/* <button
                    onClick={() => setShowEmojiPicker((prev) => !prev)}
                    className="p-2 bg-gray-200 rounded ml-2 mr-2"
                >
                    😊
                </button> */}
                <button
                    onClick={handleSend}
                    className="ml-2 p-2 rounded"
                >
                    Send
                </button>
            </div>
        </div>
    );
};

export default ChatInput;
